import { atom } from "recoil";

const listCommissionAtom = atom({
  key: "listCommission",
  default: [],
});

export { listCommissionAtom };